module.exports = __webpack_public_path__ + "img/vip1.2dc14e49.png";